// extracted by mini-css-extract-plugin
export default {"hide-backdrop":"CustomModal_hide-backdrop__doOJC"};